import {
  PRODUCT_GROUP_TRANSLATIONS,
  PRODUCT_GROUP_TRANSLATIONS_UPDATE
} from "../action-types/product-group-translations";
import { axiosAction } from "../../utils/axiosAction";

const ENDPOINT =
  process.env.REACT_APP_ENDPOINT_PRODUCT_GROUP_TRANSLATION_ENDPOINT;

export const getProductGroupTranslation =
  (productGroupId, brand) => async dispatch => {
    return axiosAction.get(
      `${ENDPOINT}${productGroupId}/translations?brand=${brand}`,
      PRODUCT_GROUP_TRANSLATIONS,
      dispatch,
    );
  };

export const SetProductGroupTranslation = item => async dispatch => {
  try {
    dispatch({
      type: PRODUCT_GROUP_TRANSLATIONS.SUCCESS,
      payload: { data: item },
    });
  } catch ({ response }) {}
};

export const UpdateProductGroupTranslation =
  (productGroupId, brand, translationsValues) => async dispatch => {
    return axiosAction.put(
      `${ENDPOINT}${productGroupId}/translations?brand=${brand}`,
      PRODUCT_GROUP_TRANSLATIONS_UPDATE,
      dispatch,
      {
        translations: translationsValues,
      },
    );
  };
